import React, { useState, useEffect, useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import ModalAsistenciaClub from "../components/asistencia/ModalAsistenciaClub";
import VisitacionSection from "../components/visitacion/VisitacionSection";

import amiguitos from "../assets/clubs/amiguitos.png";
import guerreros from "../assets/clubs/guerreros.png";
import soldados from "../assets/clubs/soldados.png";

// Logos por id_club (los ids son fijos en el catálogo de clubs)
const LOGOS = {
  1: soldados,
  2: amiguitos,
  3: guerreros,
};

export default function AsistenciaClub() {
  const { token } = useContext(AuthContext);
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [modalClub, setModalClub] = useState(null);

  const cargarClubs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/clubs", {
        credentials: "include",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setClubs(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    cargarClubs();
  }, [cargarClubs]);

  return (
    <div className="p-6 bg-slate-50">

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Asistencia Club Bíblico</h1>
        <p className="text-sm text-slate-500 mt-0.5">Selecciona un club para pasar lista del día.</p>
      </div>

      {/* FECHA */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-6 flex items-center gap-3">
        <FaCalendarAlt className="text-slate-400" />
        <label className="text-sm font-medium text-slate-700">Fecha</label>
        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          className="border border-slate-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
        />
      </div>

      {/* CLUBS */}
      {loading ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 py-10 text-center text-sm text-slate-400">
          Cargando clubs...
        </div>
      ) : clubs.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 py-10 text-center text-sm text-slate-400">
          Aún no hay clubs registrados.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {clubs.map((c) => {
            const logo = LOGOS[c.id_club];
            return (
              <button
                key={c.id_club}
                onClick={() => setModalClub(c)}
                className="text-left bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-md transition group"
              >
                <div className="w-12 h-12 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center mb-3 overflow-hidden group-hover:bg-indigo-600 transition">
                  {logo ? (
                    <img src={logo} alt={c.nombre_club} className="w-full h-full object-contain" />
                  ) : (
                    <FaUsers className="group-hover:text-white transition" />
                  )}
                </div>
                <p className="font-semibold text-sm text-slate-800">{c.nombre_club}</p>
                <p className="text-xs text-slate-400 mt-0.5">Registrar asistencia del día</p>
              </button>
            );
          })}
        </div>
      )}

      {/* MODAL ASISTENCIA */}
      {modalClub && (
        <ModalAsistenciaClub
          club={modalClub}
          fecha={fecha}
          onClose={() => setModalClub(null)}
          onSave={() => setModalClub(null)}
        />
      )}

      {/* VISITACIÓN */}
      <div className="mt-6">
        <VisitacionSection fecha={fecha} />
      </div>
    </div>
  );
}
